<template>
  <DashboardAppointments
    :appointments="nextWeekAppointments"
    title-key="services/concierge_dashboard.next_week"
    :display-hour="false"
    :display-vehicle-link="false"
    date-hour-label="services/concierge_dashboard.fields.date_hour"
  />
</template>

<script>
import DashboardAppointments from './DashboardAppointments.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DashboardNextWeekAppointments',
  props: {
    nextWeekAppointments: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: { DashboardAppointments }
})
</script>
